import {
  LearnerAssignmentPublicCommentsQuery,
  LearnerAssignmentPublicCommentsQueryVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useQuery } from "@outschool/ui-apollo";
import { ClassPostCommentFragment } from "@outschool/ui-components-classroom";

export const learnerAssignmentPublicCommentsQuery = gql`
  query LearnerAssignmentPublicComments(
    $sectionUid: ID!
    $assignmentClassPostUid: ID!
    $plainText: Boolean
  ) {
    classroom(sectionUid: $sectionUid) {
      uid
      usersCanComment
    }
    assignmentClassPost(uid: $assignmentClassPostUid) {
      uid
      publicComments {
        ...ClassPost_comment
        replies {
          ...ClassPost_comment
        }
      }
    }
  }
  ${ClassPostCommentFragment}
`;

export const useLearnerAssignmentPublicCommentsQuery = ({
  sectionUid,
  assignmentClassPostUid,
  skip = false,
}: {
  sectionUid: string;
  assignmentClassPostUid: string;
  skip?: boolean;
}) =>
  useQuery<
    LearnerAssignmentPublicCommentsQuery,
    LearnerAssignmentPublicCommentsQueryVariables
  >(learnerAssignmentPublicCommentsQuery, {
    variables: { sectionUid, assignmentClassPostUid, plainText: false },
    fetchPolicy: "cache-and-network",
    skip: skip || !sectionUid || !assignmentClassPostUid,
  });
